import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TitleService } from '../../../services/title.service';
import { NavigateService } from '../../../services/navigate.service';
import { User } from '../../../models/user/user';
import { AccountService } from '../../../services/account.service';
import {LandingArea} from "../../../models/homes/landing-area";
import {LazyLoaderService} from "../../../services/lazy-loader.service";

@Component({
    encapsulation: ViewEncapsulation.None,
    templateUrl: './widget-coho-previews.page.html'
})
export class WidgetCOHOPreviewsPage {
    landingArea: LandingArea;
    currentUser: User;

    constructor(private accountService: AccountService, private activatedRoute: ActivatedRoute, private titleService: TitleService, private navigateService: NavigateService,
        private lazyLoaderService: LazyLoaderService ) {
        this.activatedRoute.data.subscribe(data => {
            this.landingArea = data['landingArea'];
        });

        accountService.watchCurrentUser().subscribe(user => {
                this.currentUser = user;
            });

        this.lazyLoaderService.loadIFrameResizer().subscribe();
    }

    scrollToInfo() {
        this.navigateService.scrollToElement("#info-start");
    }
}
